// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  deedId: __t.u64().primaryKey().name("deed_id"),
  owner: __t.identity(),
  structureType: __t.string().name("structure_type"),
  lotsRequired: __t.u8().name("lots_required"),
  baseMaintPerHour: __t.u32().name("base_maint_per_hour"),
  redeedFactor: __t.u8().name("redeed_factor"),
  itemCap: __t.u32().name("item_cap"),
  isCivic: __t.bool().name("is_civic"),
  packed: __t.bool(),
  storedMaint: __t.i64().name("stored_maint"),
  noTrade: __t.bool().name("no_trade"),
  createdAt: __t.timestamp().name("created_at"),
});
